import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["type", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import styled from 'styled-components';
import { dropIn } from 'styles/animations';
import { typeScale, spacing } from 'styles/globals';
import { jsx as _jsx } from "react/jsx-runtime";
export var ALERT_STYLES = ['fail', 'success', 'info'];
export var AlertTypes = /*#__PURE__*/function (AlertTypes) {
  AlertTypes["SUCCESS"] = "success";
  AlertTypes["FAIL"] = "fail";
  AlertTypes["INFO"] = "info";
  return AlertTypes;
}({});
var AlertWrapperTypes = /*#__PURE__*/function (AlertWrapperTypes) {
  AlertWrapperTypes["SUCCESS"] = "alert-success";
  AlertWrapperTypes["FAIL"] = "alert-fail";
  AlertWrapperTypes["INFO"] = "alert-info";
  return AlertWrapperTypes;
}(AlertWrapperTypes || {});
var AlertWrapper = styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'type';
  }
}).withConfig({
  displayName: "Alert__AlertWrapper",
  componentId: "sc-116t21k-0"
})(["position:relative;padding:0 ", ";font-size:", ";border-left:", " solid ", ";animation:", " 0.45s ease-out both;"], spacing.s, typeScale.s, spacing.xxs, function (p) {
  return p.theme.globals.colorBlocks[p.type];
}, dropIn);
export var alertTypeMap = {
  success: AlertWrapperTypes.SUCCESS,
  info: AlertWrapperTypes.INFO,
  fail: AlertWrapperTypes.FAIL
};
var Alert = function Alert(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? AlertTypes.FAIL : _ref$type,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var alertType = alertTypeMap[type] || type;
  return /*#__PURE__*/_jsx(AlertWrapper, _objectSpread(_objectSpread({}, otherProps), {}, {
    type: alertType,
    "data-qa-alert-type": alertType,
    children: children
  }));
};
export default Alert;